import {EX} from "./exclaim.ts";
import {FileUtils} from "./FileUtils.js";
import {commonAjaxBeforeSend, getAjaxFailErrorMessage, registerJQueryExtensions} from "./jquery-exclaim-util.js";
import {toBoolean} from "./ValueUtils.ts";
import {dataTable, dialog, linearProgress, menu, ripple, select, textField, topAppBar} from "material-components-web";
import "@webcomponents/webcomponentsjs";
import "jquery";
import {DefaultMessages} from "./localization/DefaultMessages.ts";
import {ExclaimApplication} from "./ExclaimApplication.ts";

let prefilledDialog;
let alertDialog;
let busyDialog;
let selects;

function initializeMdcElements() {
    // Instantiation of the MDC elements we use
    [].map.call(document.querySelectorAll('.mdc-top-app-bar'), (el) => {
        return new topAppBar.MDCTopAppBar(el);
    });
    const prefilledDialogElement = document.getElementById('prefilled-dialog');
    if (prefilledDialogElement) {
        prefilledDialog = new dialog.MDCDialog(prefilledDialogElement);
    }
    const alertDialogElement = document.getElementById('alert-dialog');
    if (alertDialogElement) {
        alertDialog = new dialog.MDCDialog(alertDialogElement);
        alertDialog.scrimClickAction = "";
        alertDialog.escapeKeyAction = "";
    }
    const busyDialogElement = document.getElementById('busy-dialog');
    if (busyDialogElement) {
        busyDialog = new dialog.MDCDialog(busyDialogElement);
    }
    [].map.call(document.querySelectorAll('.mdc-text-field'), (el) => {
        return new textField.MDCTextField(el);
    });
    [].map.call(document.querySelectorAll('.mdc-fab'), (el) => {
        return new ripple.MDCRipple(el);
    });
    [].map.call(document.querySelectorAll('.mdc-button'), (el) => {
        return new ripple.MDCRipple(el);
    });
    [].map.call(document.querySelectorAll('.mdc-icon-button'), (el) => {
        const r = new ripple.MDCRipple(el);
        r.unbounded = true;
        return r;
    });
    selects = [].map.call(document.querySelectorAll('.mdc-select'), (el) => {
        return new select.MDCSelect(el);
    });
    [].map.call(document.querySelectorAll('.mdc-data-table'), (el) => {
        return new dataTable.MDCDataTable(el);
    });
    [].map.call(document.querySelectorAll('.mdc-linear-progress'), (el) => {
        return new linearProgress.MDCLinearProgress(el);
    });
}

function showAllErrorMessages() {
    const $form = $('#submit-a-claim-form');

    // We need to explicitly "validate" the MDCSelect UI elements
    // as their backing controls are hidden and thus do not get validated
    selects.forEach((e) => {
        if (e && e instanceof select.MDCSelect && e.required) {
            // Read the validity and then set it again to ensure messages/state is set correctly
            // noinspection UnnecessaryLocalVariableJS
            const v = e.valid;
            e.valid = v;
        }
    });
    $form.find(":invalid").each((index, node) => {
        const message = node.validationMessage;
        const $label = $(node).closest('label.mdc-text-field');
        if (message && $label) {
            $label.parent().find('.mdc-text-field-helper-text--validation-msg').text(message);
            $label.addClass('mdc-text-field--invalid');
        }
    });
}


function postClaim(recaptchaToken) {
    // Retrieve the form data
    const formElement = document.getElementById("submit-a-claim-form");
    const fd = new FormData(formElement);

    // Post the data to the server
    return new Promise((resolve, reject) => {
        $.ajax({
            url: "submit-a-claim",
            method: "POST",
            contentType: false,
            processData: false,
            dataType: "json",
            data: fd,
            beforeSend: (xhr, settings) => {
                commonAjaxBeforeSend(xhr, settings);
                xhr.setRequestHeader("X-g-recaptcha-response", recaptchaToken);
            }
        })
            .done(() => {
                window.location.href = "submit-a-claim/thank-you";
                resolve();
            })
            .fail((jqXHR, textStatus) => {
                // Do not use genericAjaxOnFail() as it uses jQueryUI for dialogs
                const now = new Date();
                const msg = getAjaxFailErrorMessage(jqXHR, textStatus) +
                    '\n\n' + now.toISOString();
                showAlertDialog(msg);
                reject(new Error(msg));
            });
    });
}

function submitButtonClick(e) {
    const formElement = document.getElementById("submit-a-claim-form");

    e.preventDefault();

    showAllErrorMessages();
    if ((typeof formElement.checkValidity === "function" && !formElement.checkValidity()) ||
        formElement.querySelector(".mdc-select--invalid")) {
        showAlertDialog(EX.Messages.prop("Submit_Dialog_Fill_Required_Fields"), true);
        return;
    }

    // Show a "busy" indicator
    busyDialog.open();
    const removeBusyDialog = () => busyDialog.close();

    const enabled = toBoolean(document.body.dataset.recaptchaEnabled, true);
    const key = document.body.dataset.recaptchaKey;

    // Need to fetch this later in the execution of the JS, otherwise, it's not initialized
    // noinspection SpellCheckingInspection,JSUnresolvedReference
    const grecaptcha = window.grecaptcha;

    // Note that server will still enforce the reCAPTCHA check even if this is "skipped" by a malicious user
    if (enabled && key && grecaptcha) {
        grecaptcha.ready(() => {
            // The action value used here needs to match the expected value by
            // the server based on the path of the request being invoked (with
            // character replacements)
            grecaptcha
                .execute(key, {action: "_submit_a_claim"})
                .then(postClaim)
                // Remove the "busy" indicator
                .then(removeBusyDialog, removeBusyDialog)
                .catch(() => { /* do nothing */});
        });
    } else {
        postClaim()
            // Remove the "busy" indicator
            .then(removeBusyDialog, removeBusyDialog)
            .catch(() => { /* do nothing */});
    }

    return false;
}

function focusErrorField() {
    $(":invalid, .mdc-select--invalid > .mdc-select__anchor", $("#submit-a-claim-form"))
        .first()
        .trigger("focus");

    alertDialog.unlisten('MDCDialog:closed', focusErrorField);
}

function showAlertDialog(msg, listen) {
    $("#alert-dialog-content")
        .empty()
        .append(
            $("<p></p>", {
                "class": "alert-dialog-text",
                text: msg
            })
        );
    alertDialog.open();
    if (listen) {
        alertDialog.listen('MDCDialog:closed', focusErrorField);
    }
}

function showPrefilledLink() {
    const url = window.location.href.split("?")[0] + '?' +
        // Include the language used (as it's not part of the form fields)
        'lang=' + encodeURIComponent(EX.language) + '&' +
        // Filter the fields to exclude the XSRF token as we don't
        // want that in the link; and filter fields without values
        $('#submit-a-claim-form input[name!="xsrf"], #submit-a-claim-form textarea')
            .filter((index, element) => {
                return String($(element).val()) !== '';
            })
            .serialize();
    $('#prefilled-dialog-content input')
        .val(url)
        .trigger("focus")
        .trigger("select");
    prefilledDialog.open();
}

function onCopyToClipboardClicked(e) {
    e.preventDefault();
    navigator.clipboard
        .writeText($('#prefilled-dialog-content input').val())
        .then(() => prefilledDialog.close());
}

function onInsuredPostalCodeBlurred(e) {
    const postalCode = e.target.value;
    $.ajax({
        type: 'GET',
        url: "submit-a-claim/resolve-postal-code",
        data: {
            postalCode: postalCode
        }
    }).done((data) => {
        if (data?.cityName) {
            $('input[name="insured-city"]')
                .val(data.cityName)
                .trigger("focus");
        }
        if (data?.provinceName) {
            $('input[name="insured-province"]')
                .val(data.provinceName)
                .trigger("focus");
        }
    }).fail((_xhr, _status, error) => {
        console.log("Failed to fetch postal codes: %s", error);
    });
}

function deleteAttachment(e) {
    $(e.target).parents("tr").remove();
    $("#attach-file-button").enable();
}

function asNumberOrDefault(val, defaultVal) {
    if (!val) {
        return defaultVal;
    }
    const n = Number(val);
    return Number.isNaN(n) ? defaultVal : n;
}

const ONE_MEGABYTE = 1024 * 1024;
const MAX_FILES = asNumberOrDefault(document.body.dataset.maxAttachments, 5);
const MAX_FILE_SIZE = asNumberOrDefault(document.body.dataset.maxAttachmentFileSize, 10 * ONE_MEGABYTE);

function filePermitted(file) {
    return FileUtils.validateFileExtension(file.name);
}

function onFileAdded(e) {
    // If there is no file set for the element...do nothing
    if (!e?.target?.files || e.target.files.length !== 1) {
        return;
    }

    const file = e.target.files[0];
    const filename = file.name;
    const filesize = file.size;

    // Filter files by size here to avoid files that are too large
    // being added by user
    if (filesize > MAX_FILE_SIZE) {
        console.trace('Selected file size exceeds the maximum size of %d', MAX_FILE_SIZE);
        e.target.value = ''; // Clear the selected file
        // Display error message to the user to tell them the file is too big
        showAlertDialog(EX.Messages.prop("Submit_Dialog_FileTooBig", MAX_FILE_SIZE / ONE_MEGABYTE));
        return;
    }

    // Filter files by extension or MIME type here to avoid unsupported files
    if (!filePermitted(file)) {
        console.trace('Selected file type is not permitted');
        e.target.value = ''; // Clear the selected file
        showAlertDialog(EX.Messages.prop("Submit_Dialog_FileType"));
        return;
    }

    const parent = e.target.parentElement;
    const $element = $(e.target);

    // Remove the "id" attribute from this element, hide it, and remove
    // it from the DOM (we'll add it back later in a different place)
    $element
        .removeAttr("id")
        .hide()
        .detach();

    // Insert a new file input element to allow the user to add another file
    $("<input/>", {
        id: "attached-file-input",
        name: "attached-file",
        type: "file",
        tabIndex: -1, // button is tab-able, but this is hidden, so don't allow tabbing
        "aria-labelledby": "attach-file-label",
        on: {
            change: onFileAdded,
        }
    }).appendTo(parent);

    const $mdcButton = $('<button class="mdc-icon-button material-icons" type="button">clear</button>')
        .on("click", deleteAttachment);
    const mdcButtonRipple = new ripple.MDCRipple($mdcButton[0]);
    mdcButtonRipple.unbounded = true;

    // Create a new table row with the file name, file size, and the delete button
    const $newRow = $("<tr></tr>", {
        "class": "mdc-data-table__row"
    }).append(
        $("<th></th>", {
            "scope": "row",
            "class": "mdc-data-table__cell monospace-font",
            text: filename
        }).append($element),
        $("<td></td>", {
            "class": "mdc-data-table__cell mdc-data-table__cell--numeric",
            text: FileUtils.formatFileSize(filesize)
        }),
        $("<td></td>", {
            "class": "mdc-data-table__cell"
        }).append($mdcButton)
    );
    $("#attached-file-list tbody").append($newRow);

    // Limit the number of files the user can add
    if ($("#attached-file-list tbody tr").length >= MAX_FILES) {
        $("#attach-file-button").disable();
    }
}

function onAttachFileButtonClicked(e) {
    e.preventDefault();
    $('#attached-file-input').trigger("click");
}

function onPageReady() {
    if (!(EX instanceof ExclaimApplication)) {
        throw new Error("EX object is not an ExclaimApplication object -- something is very wrong.");
    }
    const app = EX;

    // The localization system (EX.Messages)
    const messages = new DefaultMessages({locale: app.locale});
    app.Messages = messages;
    messages.load().catch(err => console.error("Error during message loading: %s", err));

    initializeMdcElements();

    const langMenuEl = document.getElementById('language-menu');
    if (langMenuEl) {
        const langMenu = new menu.MDCMenu(langMenuEl);
        $('#toggle-language-menu').on('click', () => {
            langMenu.open = true;
        });
    }

    if (prefilledDialog) {
        $('#copy-to-clipboard').on('click', onCopyToClipboardClicked);
        $('#pre-filled-link-button').on('click', showPrefilledLink);
    }

    $('#submit-button')
        .on('click', submitButtonClick)
        .removeAttr('disabled');

    $('input[name="insured-postal-code"]').on("blur", onInsuredPostalCodeBlurred);

    $('#attached-file-input').on("change", onFileAdded);
    $("#attach-file-button").on("click", onAttachFileButtonClicked);
}

registerJQueryExtensions();

// This is an entry point file, so we need to call the page init function here
window.addEventListener('load', onPageReady);
